import React from 'react';

const techCategories = [
  { category: 'Frontend',         technologies: ['React', 'Next.js', 'Vue.js', 'Angular', 'TypeScript', 'Tailwind CSS', 'Redux', 'GraphQL'] },
  { category: 'Backend',          technologies: ['Node.js', 'Python', 'Java', 'Go', 'Ruby', '.NET', 'PHP', 'Rust'] },
  { category: 'Mobile',           technologies: ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Xamarin', 'Ionic', 'PWA', 'Capacitor'] },
  { category: 'Database',         technologies: ['PostgreSQL', 'MongoDB', 'MySQL', 'Redis', 'Elasticsearch', 'DynamoDB', 'Firebase', 'Oracle'] },
  { category: 'Cloud & DevOps',   technologies: ['AWS', 'Google Cloud', 'Azure', 'Docker', 'Kubernetes', 'Jenkins', 'GitLab CI', 'Terraform'] },
  { category: 'AI & ML',          technologies: ['TensorFlow', 'PyTorch', 'OpenAI', 'Scikit-learn', 'Keras', 'Computer Vision', 'NLP', 'LangChain'] },
];

const Technologies = () => {
  return (
    <section className="relative py-24 md:py-32">
      <div className="frame">
        {/* Masthead */}
        <header className="grid grid-cols-12 gap-x-6 lg:gap-x-10 items-end pb-6 border-b border-ink">
          <div className="col-span-12 lg:col-span-5 flex items-center gap-3">
            <span className="section-num">06 / Stack</span>
            <span className="label-muted">Technical inventory</span>
          </div>
          <div className="col-span-12 lg:col-span-7 mt-6 lg:mt-0">
            <h2 className="display-lg">
              Technology <span className="text-accent">Stack</span>
            </h2>
            <p className="mt-5 max-w-measure text-ink-soft leading-relaxed">
              We leverage cutting-edge technologies to build robust, scalable, and
              future-proof applications.
            </p>
          </div>
        </header>

        {/* Categories grid */}
        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {techCategories.map((cat, idx) => (
            <div key={cat.category} className="card-tech p-6 md:p-7">
              <div className="flex items-center justify-between pb-4 mb-5 border-b border-rule-soft">
                <h3 className="font-display font-semibold text-lg md:text-xl tracking-tight text-ink">
                  {cat.category}
                </h3>
                <span className="label-muted">0{idx + 1} / 06</span>
              </div>

              <ul className="flex flex-wrap gap-1.5">
                {cat.technologies.map((t) => (
                  <li
                    key={t}
                    className="font-mono text-[12px] px-2.5 py-1 bg-paper border border-rule-soft text-ink-soft hover:bg-lime hover:border-ink hover:text-ink transition-colors cursor-default"
                  >
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom message */}
        <div className="mt-12 card-tech p-8 md:p-10 text-center">
          <h3 className="font-display font-semibold text-2xl md:text-3xl tracking-tight text-ink">
            Not seeing your preferred technology?
          </h3>
          <p className="mt-4 max-w-2xl mx-auto text-ink-soft leading-relaxed">
            Our versatile team can adapt to your existing tech stack or recommend
            the best technologies for your specific needs.
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="btn-ghost mt-6"
          >
            <span>Discuss Your Tech Stack</span>
            <span aria-hidden>→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Technologies;
